import React from 'react';

import { useVariantDetailPage } from '../../../../api/hooks/useVariantDetailPage.hook';
import { VariantImageType } from '../../../../api/models/variant-image-type';
import { TypographyVariantsEnum } from '../../../../utils/_enums/typeography-variants.enum';
import {useAppSelector} from '../../../../utils/_hooks/hooks';
import useFilterAttachments from '../../../../utils/_hooks/useFilterAttachments.hook';
import { Typography } from '../../../_shared/typography/typography';
import styles from './unlockables-box.module.scss';

const UnlockablesBox = (): JSX.Element => {
    const attachments = useAppSelector(state => state.productSlice.attachments);
    const data = useVariantDetailPage();

    const unlockables = useFilterAttachments(VariantImageType.ADDITIONAL_FILES, attachments);

    if (data && unlockables && unlockables.length > 0) {
        return (
            <div className={styles['unlockables-box']}>
                <Typography variant={TypographyVariantsEnum.HEADING4_BOLD}>
                    {data.unlockables.headlineContent}
                </Typography>
                {unlockables.map((item) => (
                    <div key={item.id} className={styles['unlockable-item']}>
                        <Typography
                            variant={TypographyVariantsEnum.MOBILENAVLINK}
                        >
                            {item.name}
                        </Typography>
                        <Typography
                            variant={TypographyVariantsEnum.CAPTION}
                            element={'span'}
                        >
                            {item.description}
                        </Typography>
                    </div>
                ))}
            </div>
        );
    } else {
        return <div />;
    }
};

export default UnlockablesBox;
